import Letterhead from "../Reusable/Letterhead2";
import MetaInfo from "../Reusable/MetaInfo2";
import SubjectLine from "../Reusable/SubjectLine2";
import Signature from "../Reusable/Signature2";


interface MisconductLetterProps {
  refNo: string;
  date: string;
  name: string;
  address: string;
  incidentDate: string;
  incident: string;
}

const MisconductLetter = ({ refNo, date, name, address, incidentDate, incident }: MisconductLetterProps) => (
  <div className="p-10 rounded-lg max-w-2xl mx-auto space-y-4">
    <Letterhead/>
    <hr className=" mx-auto w-4/4 border-t-2 border-black"/>
    <MetaInfo refNo={refNo} date={date} name={name} address={address} />
    <SubjectLine subject="Warning Letter for Misconduct" />

    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
      This letter serves as a formal warning regarding an incident of misconduct observed on <b>{incidentDate}</b>. 
      It has been brought to our attention that your behavior in relation to <b>{incident}</b> is not in line with the standards of conduct expected at OptimHealth andWellness Pvt. Ltd.
    </p>
    <br/>
    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
    We would like to emphasize that such actions create an unpleasant working environment and are unacceptable. 
    While we value your contributions to the team, it is important that all
    employees maintain professional behavior, mutual respect and compliance with company policies.
    </p>
    <br/>
    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
    Please consider this a <b>serious reminder</b> to correct your behavior immediately. Any further
    instance of misconduct may result in stricter disciplinary action, up to and including
    termination of employment.  
    </p>
    <br/>
    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
    We believe that you can take this as an opportunity to reflect and change with the values andexpectations of the organization. 
    We trust that such behavior will not recur in the future.
    </p>

    <Signature />
  </div>
);

export default MisconductLetter;
